var map = {
	"./en-US": [
		"743d",
		"lang-en-US-lang",
		"lang-en-US"
	],
	"./en-US.js": [
		"743d",
		"lang-en-US-lang",
		"lang-en-US"
	],
	"./en-US/lang": [
		"799e",
		"lang-en-US-lang"
	],
	"./en-US/lang.js": [
		"799e",
		"lang-en-US-lang"
	],
	"./en-US/setting": [
		"5030",
		"lang-en-US-setting"
	],
	"./en-US/setting.js": [
		"5030",
		"lang-en-US-setting"
	],
	"./zh-CN": [
		"2807"
	],
	"./zh-CN.js": [
		"2807"
	],
	"./zh-CN/lang": [
		"8928"
	],
	"./zh-CN/lang.js": [
		"8928"
	],
	"./zh-CN/setting": [
		"5436"
	],
	"./zh-CN/setting.js": [
		"5436"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4aa4";
module.exports = webpackAsyncContext;